import { mapCollection } from '../../utils/collection.utils';
import { parseNumber } from '../../utils/number.utils';
import { SchedulerTaskSubTaskSimple } from '../scheduler-task-subtask-simple';
import { ModelTimelineSimpleBuilder } from './model-time-line-simple.builder';

export class SchedulerTaskSubTaskSimpleBuilder {
  static fromJson(json) {
    return (json)
      ? new SchedulerTaskSubTaskSimple(
        json.hash,
        json.identifier,
        json.current,
        json.sent,
        parseNumber(json.sendDate),
        parseNumber(json.programsDuration),
        json.running,
        ModelTimelineSimpleBuilder.fromList(json.modelTimeLines)
      )
      : null;
  }

  static fromList(list) {
    return mapCollection(SchedulerTaskSubTaskSimpleBuilder.fromJson, list);
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/scheduler-task-subtask-simple.builder.ts